import React, { useRef, useCallback, useState } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../../../components/Input';
import { ContainerCoupon, ColInput, Button } from './styles';
import { useCheckoutFunction } from '../../../../hooks/useCheckoutFunctions';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../../store/createStore';
import Loading from '../../../../components/Loading';

const ApplyCoupon: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [coupon, setCoupon] = useState('');
  const { loading, checkout } = useSelector((state: StoreState) => state.checkout);
  const { handleApplyCoupon } = useCheckoutFunction();
  const { onTranslation: t } = useTranslation();

  // Handle applying the coupon
  const onHandleApplyCoupon = useCallback(() => {
    if (!coupon) return;

    handleApplyCoupon(coupon, `${t('main.messages_toast.coupon_invalid')}`);
    setCoupon('');
  }, [handleApplyCoupon, coupon, t]);

  if (loading) {
    return <Loading size={20} />;
  }

  return (
    <ContainerCoupon>
      <Form ref={formRef} onSubmit={() => {}}>
        <ColInput>
          <Input
            name="coupon"
            textLabel={`${t('main.new_checkout.view_checkout.apply_coupon')}`}
            Border="1px solid var(--primary)"
            formRef={formRef}
            value={checkout.coupon_code || coupon}
            onChange={e => setCoupon(e.target.value)} // Update state when input changes
            disabled={!!checkout.coupon_code}
          />
        </ColInput>
        <Button type="button" onClick={onHandleApplyCoupon}
          color={
            checkout.coupon_code ?
            'green'
            : 'var(--primary)'
          }
          disabled={!!checkout.coupon_code}
        >
          { checkout.coupon_code ? 'Cupom aplicado com sucesso!' :
          t('main.new_checkout.view_checkout.apply')}
        </Button>
        {/* {checkout.coupon_code && (
            <CouponApplied>
              {t('main.new_checkout.view_checkout.coupon_applied')}:{' '}
              {checkout.coupon_code}
             {/*  <RemoveButton onClick={onRemoveCoupon}>
                <FaTrashAlt />
              </RemoveButton> 
            </CouponApplied>
          )} */}
      </Form>
    </ContainerCoupon>
  );
};

export default ApplyCoupon;
